import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';


@Directive({
    selector: '[appStoreName]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: StoreNameDirective,
            multi: true,
        }
    ],
    standalone: false
})
export class StoreNameDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
   return /^(?![<.\s>])(?!.*[<\s>]$)[a-zA-ZÀ-ÿčę0-9.\s]+(?:[-_:%&#/\\()'`\u2122.+][a-zA-ZÀ-ÿčę0-9.)\s]+)*$/.test(control.value)
     ? null
     : { invalid : true };
 }
}
